import {
  ColumnDef,
  getCoreRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table';
import { Activities } from './queryOptions';
import { ActionButton, TableCell } from '@maia/ui';
import { IconSearchAlt, mapper } from '@maia/icons';
import { DrawerStore, useDrawerStore } from './../../../stores/drawer.store';
import {
  DocumentPreviewStore,
  useDocumentPreviewStore,
} from './../../../stores/document-preview.store';

type Activity = Activities['response'][number];

type TableMeta = {
  openDrawer: DrawerStore['openDrawer'];
  openDocument: DocumentPreviewStore['open'];
};

const columns: ColumnDef<Activity>[] = [
  {
    accessorKey: 'date',
    header: 'Datum',
    cell: ({ row }) => <TableCell.Date date={row.original.date} />,
  },
  {
    accessorKey: 'message',
    header: 'Onderwerp',
    cell: ({ row }) => (
      <TableCell.Activity
        icon={mapper(row.original.icon)}
        title={row.original.title}
        subTitle={row.original.message}
      />
    ),
  },
  {
    accessorKey: 'type',
    header: 'Type',
    enableSorting: false,
    cell: ({ row }) => <TableCell.Text text={row.original.type} />,
  },
  {
    id: 'actions',
    cell: ({ table, row }) => {
      return (
        <div className="flex gap-x-12 items-center">
          <ActionButton
            icon={IconSearchAlt}
            size="small"
            onPress={() => {
              if (row.original.type === 'Email') {
                (table.options.meta as TableMeta).openDocument({
                  type: 'email',
                  title: row.original.message,
                  data: row.original.content,
                });
              } else {
                (table.options.meta as TableMeta).openDrawer({
                  type: 'activity',
                  data: row.original,
                });
              }
            }}
          />
        </div>
      );
    },
  },
];

export function useActivitiesTable(data?: Activities) {
  const { openDrawer } = useDrawerStore();
  const openDocumentPreview = useDocumentPreviewStore((state) => state.open);

  return useReactTable({
    columns,
    data: data?.response ?? [],
    rowCount: data?.response.length,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    manualPagination: true,
    manualSorting: true,
    manualFiltering: true,
    meta: {
      openDrawer,
      openDocument: openDocumentPreview,
    },
  });
}
